// Logout.tsx
import React from 'react'
import { Button, useMediaQuery, useTheme, Tooltip } from '@mui/material'
import { LogoutIcon } from '../../../assets/icons/LogoutIcon'

interface LogoutProps {
    logout: () => void
    isIconOnly?: boolean
}

const Logout: React.FC<LogoutProps> = ({ logout, isIconOnly = false }) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    if (isMobile) {
        return (
            <Button
                fullWidth
                variant="text"
                startIcon={<LogoutIcon />}
                onClick={logout}
                sx={{
                    justifyContent: 'flex-start',
                    padding: '1rem',
                    color: 'text.primary',
                    fontSize: '0.95rem',
                    fontWeight: 500,
                    textTransform: 'none',
                    '&:hover': {
                        backgroundColor: 'var(--bg-hover)',
                    },
                    '&:active': {
                        backgroundColor: 'rgba(220, 220, 220, 0.5)',
                    },
                }}
            >
                Logout
            </Button>
        )
    }

    if (isIconOnly) {
        return (
            <Tooltip title="Logout" placement="right">
                <Button
                    variant="text"
                    onClick={logout}
                    color="secondary"
                    sx={{
                        minWidth: '60px',
                        width: '60px',
                        height: '60px',
                        padding: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'text.primary',
                        borderRadius: '8px',
                        '&:hover': {
                             backgroundColor: 'var(--bg-hover)',
                        },
                        // '&:active': {
                        //     backgroundColor: 'rgba(220, 220, 220, 0.5)',
                        // },
                    }}
                >
                    <LogoutIcon />
                </Button>
            </Tooltip>
        )
    }

    return (
        <Button
            fullWidth
            variant="text"
            startIcon={<LogoutIcon />}
            onClick={logout}
            sx={{
                justifyContent: 'flex-start',
                padding: '0.75rem 0.625rem',
                color: 'text.primary',
                fontSize: '0.95rem',
                fontWeight: 500,
                textTransform: 'none',
                borderRadius: '8px',
                gap: '0.625rem',
                '&:hover': {
                    backgroundColor: 'var(--bg-hover)',
                },
                '&:active': {
                    backgroundColor: 'var(--bg-hover)',
                    opacity: 0.8
                },
            }}
        >
            Logout
        </Button>
    )
}

export default Logout
